// These colors are described in "Color Mapping Guide-v2-20250619_181332.pdf"

import { DocumentType } from '../../api/dto';

const DEFAULT = 'rgb(61,185,211)';

const GROUP_COLORS: Record<string, string> = {
    // Beams (BE)
    'BE-ABP': 'rgb(255,192,0)',
    'BE-BI': 'rgb(187,182,0)',
    'BE-CO': 'rgb(255,147,183)',
    'BE-EA': 'rgb(91,155,213)',
    'BE-GM': 'rgb(255,102,255)',
    'BE-ICS': 'rgb(192,0,0)',
    'BE-OP': 'rgb(237,125,49)',
    'BE-RF': 'rgb(191,144,0)',

    // Engineering (EN)
    'EN-AA': 'rgb(192,0,0)',
    'EN-ACE': 'rgb(112,48,160)',
    'EN-CV': 'rgb(0,176,240)',
    'EN-EA': 'rgb(91,155,213)',
    'EN-EL': 'rgb(0,32,96)',
    'EN-HE': 'rgb(68,114,196)',
    'EN-MME': 'rgb(0,142,255)',
    'EN-SMM': 'rgb(255,102,255)',
    'EN-STI': 'rgb(105,216,255)',

    // Experimental Physics (EP)
    'EP-ADE': 'rgb(255,94,72)',
    'EP-ADO': 'rgb(255,0,102)',
    'EP-AIO': 'rgb(255,89,0)',
    'EP-CMX': 'rgb(255,152,125)',
    'EP-LBO': 'rgb(255,119,128)',

    // Health, Safety & Environment (HSE)
    'HSE-FB': 'rgb(0,107,106)',
    'HSE-OHS': 'rgb(0,131,174)',
    'HSE-RP': 'rgb(0,97,86)',

    // Information Technology (IT)
    'IT-CS': 'rgb(0,174,219)',

    // Site Management & Buildings (SMB)
    'SMB-SE': 'rgb(131,60,11)',
    'SMB-SIS': 'rgb(133,87,33)',

    // Accelerator Systems (SY)
    'SY-ABT': 'rgb(55,86,35)',
    'SY-BI': 'rgb(255,255,0)',
    'SY-EPC': 'rgb(83,129,53)',
    'SY-STI': 'rgb(0,176,240)',

    // Technology (TE)
    'TE-ABT': 'rgb(55,86,35)',
    'TE-CRG': 'rgb(0,176,80)',
    'TE-EPC': 'rgb(83,129,53)',
    'TE-MPE': 'rgb(135,176,85)',
    'TE-MSC': 'rgb(84,145,71)',
    'TE-VSC': 'rgb(168,208,141)',
};

const SAFETY_DOC_COLORS: Record<string, string> = {
    [DocumentType.NDC]: 'rgb(255, 102, 102)',
    [DocumentType.IS37]: 'rgb(255, 165, 0)',
    [DocumentType.VIC]: 'rgb(255, 215, 0)',
    [DocumentType.LOK]: 'rgb(0, 153, 0)',
    [DocumentType.FP]: 'rgb(255, 69, 0)',
    [DocumentType.DIMR]: 'rgb(70, 130, 180)',
};

export function getOrgUnitColor(section: string): string {
    return GROUP_COLORS[section as keyof typeof GROUP_COLORS] ?? DEFAULT;
}

export function getSafetyDocumentColor(type: DocumentType): string {
    return SAFETY_DOC_COLORS[type] ?? DEFAULT;
}
